//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { allowAccessibilityColors } from "@/assets/js/appFunc";
import check from "./CompareJsonTypeOf";
import CompareJsonBody from "./CompareJsonBody.vue";
import parseData from "./CompareJsonParsing";

export default {
    components: {
        CompareJsonBody
    },
    props: {
        oldData: {
            type: [Object, Array],
            default: () => ({})
        },
        newData: {
            type: [Object, Array],
            default: () => ({})
        },
        showTooltip: {
            type: Boolean,
            default: false
        },
        showAllDiff: {
            type: Boolean,
            default: false
        },
        showMarkers: {
            type: Boolean,
            default: false
        },
        showAdded: {
            type: Boolean,
            default: false
        },
        showDeleted: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            firstLine: 1,
            lastLine: 0,
            isObject: true,
            parent: true,
            merge: [],
            oldDataValues: {},
            newDataValues: {},
            extraSpaceMarkers: false,
            dataShowAllDifferences: false,
            parentAllAdd: false,
            parentAllDeleted: false,
            differences: {
                added: 0,
                deleted: 0,
                updated: 0
            }
        };
    },
    computed: {
        getCompareProps() {
            return {
                oldData: this.oldData,
                newData: this.newData,
                merge: this.merge,
                needKey: this.isObject,
                showAllDiff: this.dataShowAllDifferences,
                showMarkers: this.showMarkers,
                showTooltip: this.showTooltip,
                showAdded: this.showAdded,
                showDeleted: this.showDeleted,
                objectType: this.isObject
            };
        },
        isTheSameType() {
            return check.getType(this.oldData) === check.getType(this.newData);
        },
        getLastLine() {
            return this.lastLine + 1;
        }
    },
    watch: {
        oldData() {
            this.getMergedData();
        },
        newData() {
            this.getMergedData();
        }
    },
    created() {
        check.checkLastLine.registerListener((val) => {
            this.lastLine = val;
        });
        this.getMergedData();
        const hasAccFeature = localStorage.getItem("accessibilityFeature");
        allowAccessibilityColors(hasAccFeature === "true");
    },
    methods: {
        getMergedData() {
            let mergeData = {};
            this.dataShowAllDifferences = this.showAllDiff;
            this.isObject = check.isObject(this.newData);
            this.differences = { added: 0, deleted: 0, updated: 0 };

            this.parentAllAdd = !!(this.oldData && !Object.keys(this.oldData).length);
            this.parentAllDeleted = !!(this.newData && !Object.keys(this.newData).length);

            if (this.parentAllAdd || this.parentAllDeleted || !this.showMarkers) {
                this.dataShowAllDifferences = true;
            }

            if (this.isObject && check.isObject(this.oldData)) {
                mergeData = check.mergeObj(this.oldData, this.newData, this.dataShowAllDifferences, this.showAdded, this.showDeleted, this.differences);
            } else if (check.isArray(this.newData) && check.isArray(this.oldData)) {
                mergeData = check.mergeArr(this.oldData, this.newData, this.dataShowAllDifferences, this.showAdded, this.showDeleted, this.differences);
            }

            if (this.showMarkers && (this.parentAllAdd || this.parentAllDeleted)) {
                const type = this.parentAllAdd ? "added" : "deleted";
                this.differences[type] += 2;
            }
            this.extraSpaceMarkers = !!(this.differences.added || this.differences.deleted || this.differences.updated);
            this.$emit("differences", this.differences);
            this.merge = parseData(mergeData);
        }
    }
};
